var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0072C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.218 12.886v7a.48.48 0 01-.149.352.48.48 0 01-.351.148h-5.5v3.563l-9-1.57V10.44l9-1.617v3.562h5.5a.48.48 0 01.351.149.48.48 0 01.149.351zm-8 3.453c0-.359-.047-.713-.14-1.062a3.053 3.053 0 00-.43-.953 2.214 2.214 0 00-.743-.68c-.297-.172-.648-.258-1.054-.258-.448 0-.839.084-1.172.25-.328.167-.602.39-.82.672a3.011 3.011 0 00-.485.977c-.104.37-.156.76-.156 1.171 0 .391.052.764.156 1.118.11.354.268.666.477.937.213.266.479.48.796.64.318.157.688.235 1.11.235a2.213 2.213 0 001.422-.5c.192-.156.36-.34.5-.555a3.01 3.01 0 00.5-1.328c.026-.224.039-.445.039-.664zm7.5 3.547v-7h-5.5v2.203l.18.18c.093.089.203.195.328.32.13.125.265.258.406.399l.39.39c.126.115.227.211.305.29a.68.68 0 00.14.109l.04-.016 3.71-3.625v1.125l-3.484 3.274a.395.395 0 01-.53 0l-1.485-1.399v3.75h5.5zm-8.797-3.468c0 .192-.02.398-.063.617a1.911 1.911 0 01-.203.593 1.314 1.314 0 01-.382.446.982.982 0 01-.602.18 1.13 1.13 0 01-.64-.173 1.36 1.36 0 01-.407-.437 2.233 2.233 0 01-.219-.601 3.457 3.457 0 010-1.305c.047-.224.123-.425.227-.602.104-.182.242-.33.414-.445.177-.115.396-.172.656-.172.24 0 .438.065.594.195.161.125.286.284.375.477.094.187.159.393.195.617.037.219.055.422.055.61z",
    fill: "#fff"
  })));
}

export default SvgMicrosoftOutlook;